document.addEventListener("DOMContentLoaded", () => {
  const search = document.getElementById("StoreSearch");
  const region = document.getElementById("RegionFilter");
  const stores = document.querySelectorAll(".store-item");
  const map = document.getElementById("StoreMap");
  const pagination = document.getElementById("Pagination");

  let currentPage = 1;
  const perPage = 12;

  // Normalize UK postcode (SW1A 1AA → SW1A)
  const normalizePostcode = val =>
    val ? val.toUpperCase().replace(/\s+/g, "").slice(0, 4) : "";

  // Click store → update map + scroll + highlight
  stores.forEach(store => {
    store.addEventListener("click", () => {
      map.src = store.dataset.map;

      map.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

      stores.forEach(s => s.classList.remove("is-active"));
      store.classList.add("is-active");
    });
  });

  function filterStores() {
    const searchVal = normalizePostcode(search.value);
    const regionVal = region.value;

    let visibleStores = [];

    // Reset nearest badges
    stores.forEach(store => {
      const badge = store.querySelector(".nearest-badge");
      if (badge) badge.setAttribute("hidden", true);
    });

    stores.forEach(store => {
      const storePostcode = normalizePostcode(store.dataset.postcode);
      const storeRegion = store.dataset.region;

      const matchPostcode =
        !searchVal || storePostcode.startsWith(searchVal);
      const matchRegion =
        !regionVal || storeRegion === regionVal;

      if (matchPostcode && matchRegion) {
        visibleStores.push(store);
        store.style.display = "block";
      } else {
        store.style.display = "none";
      }
    });

    // ⭐ Nearest store (approx logic)
    if (searchVal && visibleStores.length) {
      let bestMatch = null;
      let bestScore = 0;

      visibleStores.forEach(store => {
        const storePostcode = normalizePostcode(store.dataset.postcode);
        let score = 0;

        for (let i = 0; i < searchVal.length; i++) {
          if (storePostcode[i] === searchVal[i]) score++;
          else break;
        }

        if (score > bestScore) {
          bestScore = score;
          bestMatch = store;
        }
      });

      if (bestMatch) {
        const badge = bestMatch.querySelector(".nearest-badge");
        if (badge) badge.removeAttribute("hidden");
      }
    }

    paginateStores(visibleStores);
  }

  function paginateStores(storesList) {
    pagination.innerHTML = "";
    const totalPages = Math.ceil(storesList.length / perPage);

    storesList.forEach((store, index) => {
      store.style.display =
        index >= (currentPage - 1) * perPage &&
        index < currentPage * perPage
          ? "block"
          : "none";
    });

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement("button");
      btn.textContent = i;

      if (i === currentPage) btn.classList.add("is-active");

      btn.addEventListener("click", () => {
        currentPage = i;
        paginateStores(storesList);

        document.getElementById("StoreList").scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });

      pagination.appendChild(btn);
    }
  }

  // Reset to page 1 on filter change
  search.addEventListener("input", () => {
    currentPage = 1;
    filterStores();
  });

  region.addEventListener("change", () => {
    currentPage = 1;
    filterStores();
  });

  // Initial load
  filterStores();
});
